var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"modal-button",on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }